import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnerRatingByPartnerExcel } from '../api';

export function useExportPartnerRatingByPartnerExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportPartnerRatingByPartnerExcelReport = async (partnerGuid: string, config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnerRatingByPartnerExcel(partnerGuid, config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по партнеру.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportPartnerRatingByPartnerExcelReport };
}
